import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useApi, useWorkspace } from '~/contexts';
import { PageLoader } from '~/routes/public/pages';

function ProjectRedirect() {
  const api = useApi();
  const { workspace } = useWorkspace();
  const { projectId } = useParams();
  const { url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.www.workspaces(workspace.id).projects(projectId).key();
      const suffix = location.pathname.slice(url.length);
      history.replace({
        pathname: `/app/${workspace.key}/portfolio/projects/${data.clientKey}/${data.key}${suffix}`,
        search: location.search,
        hash: location.hash,
      });
    } catch {
      history.replace(`/app/${workspace.key}/portfolio/projects`);
    }
  }, [api, workspace, projectId, url, location, history]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return <PageLoader />;
}

export default ProjectRedirect;
